import React from "react";

export default function FormattedDate(props){
    console.log(props.date);
    let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    let months= ["Jan","Feb", "Mar", "Apr", "May","Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

    let dayOfWeek = days[props.date.getDay()];
    let day = props.date.getDate();
    let month = months[props.date.getMonth()];
    let year = props.date.getFullYear();
    let hours = props.date.getHours();
    let minutes = props.date.getMinutes();

    if (minutes < 10) {
        minutes = `0${minutes}`;
    }

    return(
    <div>
        {dayOfWeek}, {day} {month} {year} {hours}:{minutes}
    </div>
        );
    }